import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython, faNodeJs } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "C#",
    "Angular",
    "JavaScript",
    "HTML5",
    "CSS3",
    ".NET Core",
    "Node.js",
    "SQLite",
    "Git",
    "Swagger UI",
];

const labelsSecond = [
    "Java",
    "Python",
    "TypeScript",
    "Tailwind CSS",
    "Azure",
    "React",
    "Docker",
    "Postman",
    "SQL Server",
];

const labelsThird = [
    "VsCode",
    "Visual Studio",
    "IntelliJ",
    "Eclipse",
    "Trae",
    "PyCharm",
   
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faNodeJs} size="3x"/>
                    <h3>Core Technologies</h3>
                    <p>
                        I have a strong foundation in core technologies such as C#, Angular, JavaScript, HTML5, CSS3, .NET Core, Node.js, SQLite, Git, and Swagger UI.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Currently Expanding Skills:</h3>
                    <p>I am currently expanding my skills in Java, Python, TypeScript, Tailwind CSS, Azure, React, Docker, Postman, SQL Server, and Visual Studio.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Development Tools:</h3>
                    <p>I have experience with Python, Java, TypeScript, Tailwind CSS, Azure, React, Docker, Postman, SQL Server, and Visual Studio.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;